import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBag } from 'lucide-react';
const purchases = [{
  name: 'Camille D.',
  location: 'Paris'
}, {
  name: 'Léa M.',
  location: 'Lyon'
}, {
  name: 'Manon B.',
  location: 'Marseille'
}, {
  name: 'Chloé R.',
  location: 'Toulouse'
}, {
  name: 'Emma L.',
  location: 'Nice'
}, {
  name: 'Sarah P.',
  location: 'Bordeaux'
}, {
  name: 'Julie F.',
  location: 'Nantes'
}, {
  name: 'Clara T.',
  location: 'Strasbourg'
}, {
  name: 'Océane G.',
  location: 'Lille'
}, {
  name: 'Inès V.',
  location: 'Montpellier'
}, {
  name: 'Marie C.',
  location: 'Rennes'
}, {
  name: 'Pauline H.',
  location: 'Grenoble'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 18000);
    setTimeout(showPopup, 4000);
    return () => clearInterval(interval);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" data-id="element-177">
      <div className="bg-white border-2 border-brand-gold shadow-[0_0_20px_rgba(200,163,90,0.5)] rounded-lg p-2.5 pr-8 max-w-[280px] w-full relative overflow-hidden pointer-events-auto" data-id="element-178">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-gold via-brand-rose to-brand-gold" data-id="element-179"></div>

        <button onClick={() => setVisible(false)} aria-label="Fermer" className="absolute top-1.5 right-1.5 text-brand-text/50 hover:text-brand-text transition-colors" data-id="element-180">
          <XIcon className="w-4 h-4" data-id="element-181" />
        </button>

        <div className="flex items-center gap-3" data-id="element-182">
          <div className="w-10 h-10 rounded-full bg-brand-rose/10 flex items-center justify-center shrink-0 border border-brand-rose/30" data-id="element-183">
            <ShoppingBag className="w-5 h-5 text-brand-rose" data-id="element-184" />
          </div>
          <div className="leading-tight" data-id="element-185">
            <p className="font-bold text-brand-title text-sm" data-id="element-186">
              {currentPurchase.name}
            </p>
            <p className="text-[11px] text-brand-text/70 font-semibold" data-id="element-187">
              de {currentPurchase.location}, France
            </p>
            <p className="text-xs text-brand-rose font-bold mt-0.5" data-id="element-188">
              vient d'acheter DANCE PRO™
            </p>
          </div>
        </div>
      </div>
    </div>;
}